import { GetFinanceCalculationParams } from "services/motorpoint/finance";

export type FinanceSubmitEventData = {
    finance_deposit_amount: number;
    finance_term_length: number;
    finance_mileage?: number;
    finance_type: string;
    extras?: string;
};

export default function generateGtmFinanceSubmitEvent(
    params: GetFinanceCalculationParams,
    extrasString?: string
): FinanceSubmitEventData {
    return {
        finance_deposit_amount: params.preferredDepositAmount,
        finance_term_length: params.selectedTerm,
        finance_mileage: params.mileage,
        finance_type: params.selectedFinanceType,
        extras: extrasString,
    };
}
